import { Icon } from "../icons/Icon"
import { Button } from "../ui/Button"
import { useTranslation } from "react-i18next"
import { getLocalizedStyleDisplayName } from "@/i18n/style-display-name"

interface StyleNavigatorProps {
	currentIndex: number
	totalCount: number
	onPrevious: () => void
	onNext: () => void
	allStyles: Array<{ name: string }>
}

export const StyleNavigator = ({
	currentIndex,
	totalCount,
	onPrevious,
	onNext,
	allStyles,
}: StyleNavigatorProps) => {
	const { t } = useTranslation("components")
	const previousIndex = currentIndex === 0 ? totalCount - 1 : currentIndex - 1
	const nextIndex = currentIndex === totalCount - 1 ? 0 : currentIndex + 1

	const previousName = getLocalizedStyleDisplayName(allStyles[previousIndex]?.name || "", t)
	const currentName = getLocalizedStyleDisplayName(allStyles[currentIndex]?.name || "", t)
	const nextName = getLocalizedStyleDisplayName(allStyles[nextIndex]?.name || "", t)

	return (
		<div className="flex items-center gap-3">
			<Button
				variant="icon"
				size="custom"
				onClick={onPrevious}
				className="size-6 bg-transparent hover:bg-transparent"
				trackingLabel="style_navigation_previous"
				aria-label={t("styleNavigator.ariaPreviousAIStyle")}
			>
				<Icon name="left" size={24} className="text-base-400 hover:text-base-50" />
			</Button>

			<div className="flex min-w-0 items-center gap-4 p-2 text-center text-sm">
				<div
					className="w-24 truncate text-base-400 hover:text-base-50"
					title={previousName}
					onClick={onPrevious}
				>
					{previousName}
				</div>
				<div className="w-28 truncate font-medium text-base-50" title={currentName}>
					{currentName}
				</div>
				<div
					className="w-24 truncate text-base-400 hover:text-base-50"
					title={nextName}
					onClick={onNext}
				>
					{nextName}
				</div>
			</div>

			<Button
				variant="icon"
				size="custom"
				onClick={onNext}
				className="size-8 bg-transparent hover:bg-transparent"
				trackingLabel="style_navigation_next"
				aria-label={t("styleNavigator.ariaNextAIStyle")}
			>
				<Icon name="right" size={24} className="text-base-400 hover:text-base-50" />
			</Button>
		</div>
	)
}

export default StyleNavigator
